/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import FAQ from 'pagesNew/FAQ'
import { FaqPages } from '__generatedTypes__/globalTypes'
import * as classes from './styles'

export const ContentCompletion: FC = () => (
  <div css={classes.container}>
    <Typography variant="title3" css={classes.title}>
      Content Completion
    </Typography>

    <FAQ page={FaqPages.ContentCompletion} />
  </div>
)
